import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../services/loader-service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-loader',
  imports: [ProgressSpinnerModule, BlockUIModule, AsyncPipe],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader {
  loading$: Observable<boolean>;

  constructor(private loader: LoaderService) {
    this.loading$ = this.loader.loading$;
  }
}
